export default __webpack_public_path__ + "static/char-s-14-cht-f40b69300bf03ee86c2c72e8182fe232.png";